import { WarningAmberOutlined } from '@mui/icons-material';
import './ConfirmPopup.css';

const ConfirmPopup = ({
  title,
  message,
  confirmLabel,
  cancelLabel = 'Annuler',
  onConfirm,
  onCancel,
  isLoading,
  showIcon = true, // ← passer false pour masquer l'icône
}) => (
  <div className="arm-revoke-overlay">
    <div className="arm-revoke-box">
      {showIcon && (
        <div className="arm-revoke-icon"><WarningAmberOutlined /></div>
      )}
      <h3 className="arm-revoke-title">{title}</h3>
      <div className="arm-revoke-text">{message}</div>
      <div className="arm-revoke-actions">
        <button type="button" className="arm-btn-cancel" onClick={onCancel} disabled={isLoading}>{cancelLabel}</button>
        <button type="button" className="arm-btn-revoke" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? <><span className="arm-spinner" />Traitement…</> : confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmPopup;